import { CtDatamap } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    type: {
      field: 'type',
      label: 'Type',
      validator: () => true,
      type: 'string',
      required: true
    },
    description: {
      field: 'description',
      label: 'Description',
      validator: () => true,
      type: 'string',
      required: true
    },
    map: {
      field: 'map',
      label: 'map',
      validator: () => true,
      type: 'json',
      default: undefined,
      required: true
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtDatamap>(
  ContentType.Datamap, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
